<template>
  <main>
    <tux-profile-confirmation
      :cta-label="$t('button.profileSignIn')"
      @cta-click="route"
      @merchant-click="logAnalytics">
    </tux-profile-confirmation>
  </main>
</template>

<script>
import { TuxProfileConfirmation } from '@mc-alberta/tuxedo'
import { mapActions } from 'vuex'
import { ACTION, ROUTES } from '@/constants'

export default {
  name: ROUTES.PROFILE_CREATION,
  components: {
    TuxProfileConfirmation
  },
  data() {
    return {
      email: this.$route.params.email
    }
  },
  methods: {
    ...mapActions(['setAction']),
    route() {
      this.setAction(ACTION.MANAGE)
      this.$router.replace({ name: ROUTES.ENTRY, params: { email: this.email } })
    },
    logAnalytics(merchant) {
      const { name, url } = merchant
      this.$analytics.track({
        event: this.$EVENTS.MERCHANT_LOGO_CLICK,
        meta: {
          merchantName: name,
          merchantUrl: url
        }
      })
    }
  }
}
</script>
